// extracted by mini-css-extract-plugin
export default {"emailAutocompleteList":"emailAutocompleteList--xt20D form-group"};